<script setup>
import {onMounted, ref} from "vue";
import { useRoute } from "vue-router";

import SidenavItem from "./SidenavItem.vue";
import {isAuthenticated} from "@/utils/auth";

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
const hiddenMenu = ref(false);
onMounted(() => {
  if(!isAuthenticated()) {
    hiddenMenu.value = true;
  }
});
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard"
          :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="'Bảng điều khiển'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="!hiddenMenu">
        <sidenav-item
          to="/flashcard"
          :class="getRoute() === 'flashcard' ? 'active' : ''"
          :navText="'Thẻ ghi nhớ'"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="!hiddenMenu">
        <sidenav-item
            to="/quiz"
            :class="getRoute() === 'quiz' ? 'active' : ''"
            :navText="'Học tập'"
        >
          <template v-slot:icon>
            <i
                class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>


      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2"
        >
          TÀI KHOẢN
        </h6>
      </li>

      <li class="nav-item" v-if="!hiddenMenu">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="'Hồ sơ'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="hiddenMenu">
        <sidenav-item
          to="/signin"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="'Đăng nhập'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/signup"
          :class="getRoute() === 'signup' ? 'active' : ''"
          :navText="'Đăng ký'"
        >
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="!hiddenMenu">
        <sidenav-item
            to="/logout"
            :class="getRoute() === 'logout' ? 'active' : ''"
            :navText="'Đăng xuất'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>
